import { createContext } from 'react';

export type PostsContextType = {
    postsCount: number;
    setPostsCount: (count: number) => void;
};

const PostsContext = createContext<PostsContextType>({} as PostsContextType);

export default PostsContext;
